import { Fragment, useState, useEffect } from "react";
import { Container, Row, Col, Nav, Tab } from "react-bootstrap";
import Navigation from "../Navigation";
import RequireLoginComponent from "../RequireLoginComponent";
import ActiveSubstanceUnits from "./ActiveSubstanceUnits/ActiveSubstanceUnits";
import TimeIntervalUnits from "./TimeIntervalUnits/TimeIntervalUnits";
import TreatmentPeriodicities from "./TreatmentPeriodicities/TreatmentPeriodicities";
import Medications from "./Medications/Medications";
import Treatments from "./Treatments/Treatments";

const VivantaTreatmentAdmin = () => {
  const [isNotAuthenticated, setIsNotAuthenticated] = useState(false);
  const [activeKey, setActiveKey] = useState("active-substance-units");

  useEffect(() => {
    const token = localStorage.getItem("staffToken");
    if (!token) {
      setIsNotAuthenticated(true);
    } else {
      setIsNotAuthenticated(false);
    }
  }, []);

  return (
    <Fragment>
      <Navigation />
      <Container className="mt-4">
        <RequireLoginComponent isNotAuthenticated={isNotAuthenticated} />
        {!isNotAuthenticated && (
          <>
            <Row>
              <Col>
                <h1>Vivanta Treatment Administration</h1>
                <p className="text-muted">Manage treatment-related data and configurations</p>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col>
                <Tab.Container activeKey={activeKey} onSelect={(k) => setActiveKey(k || "active-substance-units")}>
                  <Nav variant="tabs">
                    <Nav.Item>
                      <Nav.Link eventKey="active-substance-units">Active Substance Units</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="time-interval-units">Time Interval Units</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="treatment-periodicities">Treatment Periodicities</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="medications">Medications</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="treatments">Treatments</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content className="mt-4">
                    <Tab.Pane eventKey="active-substance-units">
                      <ActiveSubstanceUnits />
                    </Tab.Pane>
                    <Tab.Pane eventKey="time-interval-units">
                      <TimeIntervalUnits />
                    </Tab.Pane>
                    <Tab.Pane eventKey="treatment-periodicities">
                      <TreatmentPeriodicities />
                    </Tab.Pane>
                    <Tab.Pane eventKey="medications">
                      <Medications />
                    </Tab.Pane>
                    <Tab.Pane eventKey="treatments">
                      <Treatments />
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </Col>
            </Row>
          </>
        )}
      </Container>
    </Fragment>
  );
};

export default VivantaTreatmentAdmin;
